import { render, staticRenderFns } from "./PandemicDatabase.vue?vue&type=template&id=531f1250&"
import script from "./PandemicDatabase.vue?vue&type=script&lang=js&"
export * from "./PandemicDatabase.vue?vue&type=script&lang=js&"
import style0 from "./PandemicDatabase.vue?vue&type=style&index=0&id=531f1250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports